module.exports = "/images/contract-cht-page-7.jpg?ab2f38656e5f21ab8beda013ed2f2039";